import React, {useEffect} from 'react';
import { ThemeProvider } from '@mui/material';
import GlobalStyles from '@mui/material/GlobalStyles';
import { useSelector } from 'react-redux';

import RoutesComponent from './Routes/Routes.jsx';
import createPrimaryTheme from '../theme';
import Styles from '../GlobalStyle';
import Loader from '../Components/Loader/Loader.jsx';
import echo from './Echo.js';
import { SocketProvider } from '../Hooks/useWebSocket.jsx';

function App() {
   return (
      <SocketProvider>
         <AppWithSocket />
      </SocketProvider>
   );
}

function AppWithSocket() {
   const theme = createPrimaryTheme('light');
   const { isLoading } = useSelector((state) => state.appUi);



   useEffect(() => {
      const channel = echo.channel('subscription-create-channel')
        .listen('.subscription-create', (e) => {
          console.log(e.message);
        });

        console.log(channel)
  
      return () => {
        channel.stopListening('.event.subscription-create')
               .unsubscribe();
      };
  }, []);
   // console.log("isLoading",isLoading);
   return (
      <>
         <ThemeProvider theme={theme}>
            <GlobalStyles styles={Styles(theme)} />
            <RoutesComponent />
            {isLoading && <Loader />}
         </ThemeProvider>
      </>
   );
}

export default App;
